import { SESSION_REQUEST, SESSION_FAILURE, SESSION_SUCCESS } from "../action/Initiatesession";


const initialState = {
  sessionData: null,
  loading: false,
  error: null,
  userData: ''

};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionData: action.payload,
      };
    case SESSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default sessionReducer;
